Controller.$inject = ['$scope'];

function Controller($scope) {
    const self = this;

    // Access parent hui-input-select controller
    self.getSelectCtrl = function() {
        return $scope.$parent.$inputSelectCtrl || $scope.$parent.$parent.$inputSelectCtrl;
    };

    // Get selection state directly from parent controller
    self.getIsSelected = function() {
        const selectCtrl = self.getSelectCtrl();
        return selectCtrl ? selectCtrl.isSelected(self.item) : false;
    };

    // Get multi-select state directly from parent controller  
    self.getMultiSelect = function() {
        const selectCtrl = self.getSelectCtrl();
        return selectCtrl ? selectCtrl.multiSelect : false;
    };

    self.handleClick = function(event) {
        if (!self.ngDisabled && self.item) {
            const selectCtrl = self.getSelectCtrl();
            if (selectCtrl && selectCtrl.selectItem) {
                selectCtrl.selectItem(self.item, event);
            }
            
            if (self.onClick) {
                self.onClick({$event: event, item: self.item});
            }
        }
    };
}

export function HuiInputOption() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            item: '<',
            ngDisabled: '<',
            onClick: '&?',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        link: function(scope, element, attrs, ctrl, transcludeFn) {
            if (attrs.ngDisabled) {
                scope.$watch(attrs.ngDisabled, function(newVal) {
                    ctrl.ngDisabled = newVal;
                });
            }
            
            const contentContainer = element.find('.hui-select-option-content');
            if (transcludeFn && contentContainer.length) {
                transcludeFn(scope, function(clone) {
                    contentContainer.append(clone);
                });
            }
        },
        template: () => {
            return `
                <div class="hui-menu-item hui-select-option"
                     role="option"
                     ng-attr-aria-disabled="{{$huiCtrl.ngDisabled}}"
                     ng-attr-tabindex="{{$huiCtrl.ngDisabled ? -1 : 0}}"
                     ng-class="{'active': $huiCtrl.getIsSelected(), 'disabled': $huiCtrl.ngDisabled}"
                     ng-click="$huiCtrl.handleClick($event)">
                    <div ng-if="$huiCtrl.getMultiSelect()" class="hui-select-option-icon checkbox-icon">
                        <i class="fa fa-check"></i>
                    </div>
                    
                    <div ng-if="!$huiCtrl.getMultiSelect()" class="hui-select-option-icon radio-icon">
                        <div class="radio-inner"></div>
                    </div>
                    
                    <div class="hui-select-option-content"></div>
                </div>
            `;
        }
    };
}